module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAAACXBIWXMAAAsTAAALEwEAmpwYAAABNElEQVQ4jZ3Tvy8EQRjG8e9eotDgKGkoFBKJ7Kun0ohEoSBRSYRGqTmF7gqNzun9OOI/IIqrSHhEglolQSJRUClWcUvW3Fg7ppv3eecz7xQTJUmCmfUBFWAEeAXqknYIWFEcx73ALdDlZFVJa0WhErDpQQAqZtYfAk3m5OMh0GNO/hICHfySvQGnIdC+py5gTNJ7YUjSHXDt1DckXRVFviYCqDr1LTMrB0OSjoD7TL0HaPxnIoB5Jxs2s8OiUJQkyffGzGrAstOzJ+nHJWY2RPM7PUhqtEBp0yVgDnYiaSLNt4GlTHYGTPmgdpp/b8DBLoAbYMHzsvMWKMXKwDEw6jnkXV4oA9aB2QLORykvlTQHLALPf0BtuRNlJusEVoEVoMPTsl4IyoDdwAwwDQwCT8CupNonqsdlIKhMbWsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/aboutUs/contactUs/phone.png
// module id = x9Oo
// module chunks = 1